import { render } from "./Orderpoints.vue?vue&type=template&id=9e2cb3ca"
import script from "./Orderpoints.vue?vue&type=script&lang=js"
export * from "./Orderpoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__